// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"70184123","589":"9a9d6499"}[chunkId] + ".js";
};